'use client';
import React from 'react';
import { WordpressPost } from '@benzinga/content-manager';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { Icon } from '@benzinga/core-ui';
import { isMobile } from '@benzinga/device-utils';
import styles from './CornerstoneNavigation.module.scss';

export interface CornerstoneNavigationProps {
  post: WordpressPost;
}

export const showCornerStone = (post: WordpressPost | null) => {
  return !(!post || !post.cornerstone || !post.cornerstone?.child_posts?.length);
};

export const CornerstoneNavigation: React.FC<CornerstoneNavigationProps> = ({ post }) => {
  const [expandList, setExpandList] = React.useState<boolean | null>(null);
  const [activeSubItemsClass, setActiveSubItemsClass] = React.useState<string>('hide');

  const handleClick = React.useCallback(() => {
    if (!expandList) {
      setActiveSubItemsClass('show');
    } else {
      setActiveSubItemsClass('hide');
    }
    setExpandList(!expandList);
  }, [expandList]);

  const handleSidebarVisibility = React.useCallback(() => {
    if (isMobile()) {
      setExpandList(false);
      setActiveSubItemsClass('hide');
    }
  }, []);

  React.useEffect(() => {
    handleSidebarVisibility();
  }, [handleSidebarVisibility]);

  if (!showCornerStone(post)) return <div />;

  return (
    <div className={`${styles.cornerstoneNavigation} cornerstone-navigation`}>
      <ul>
        {post.cornerstone?.parent_link && (
          <li className="parent-list-item">
            <a href={post.cornerstone.parent_link}> {post.cornerstone.parent_title}</a>
            <span className="toggle-cornerstone" onClick={handleClick}>
              {(() => {
                if (expandList !== null)
                  if (expandList === true) return <Icon className="chevron-up" icon={faChevronUp} strokeWidth={3} />;
                  else return <Icon className="chevron-down" icon={faChevronDown} strokeWidth={3} />;
                else return null;
              })()}
            </span>
          </li>
        )}
        {post.cornerstone?.child_posts.map(link => (
          <li
            className={`child-item ${post.id === link.id ? 'active current-list-item' : ''} ${activeSubItemsClass}`}
            key={link.id}
          >
            <a href={link.link}>{link.title}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const CornerstoneNavigationContainer = ({
  children,
  className,
  style,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`${styles.cornerstoneNavigation}${className ? ` ${className}` : ''}`} style={style}>
    {children}
  </div>
);
